import {
  QuestionCircleOutlined
} from "@ant-design/icons";
import { Col, Empty, Form, Input, Modal, Row, Tooltip } from "antd";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import React, { useEffect, useState } from "react";
import { KEY, lang } from "../../constants/common.const";
import { MSG_CATCH, showMessage } from "../../constants/utils";
const chartLine = {
  chart: {
    type: "spline",
  },
  title: {
    text: "",
  },
  tooltip: {
    style: {
      zIndex: 10003,
    },
    outSide:true
  },
  xAxis: {
    categories: [],
    labels: { overflow: "allow" },
  },
  yAxis: {
    title: {
      text: undefined,
    },
  },

  credits: {
    enabled: false,
  },
  plotOptions: {
    series: {
      marker: {
        enabled: true,
        radius: 2.5,
      },
      connectNulls: true,
    },
  },
  series: [
    {
      name: "",
      data: [],
    },
  ],
};

function EquipmentChart({ item, index, isPopup, isChartItem, updateCheckBox,machineName ,machineCode}) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [customAxisRanges, setCustomAxisRanges] = useState([]);
  const [editingAxisIndex, setEditingAxisIndex] = useState(null);
  useEffect(() => {
    if (
      item &&
      item.series &&
      Array.isArray(item.series) &&
      item.series.length
    ) {
      let arr = [];
      item.series.forEach((se) => {
        const arrayData = (se.data || []).filter(i => !isNaN(i))
        let min = 0,
          max = arrayData.length ? roundUpByDigit(Math.max(...arrayData)) : 0;
        const sessionData = sessionStorage.getItem(rangeKey(se.itemCode));
        if (sessionData) {
          const rangeObj = JSON.parse(sessionData);

          min = Number(rangeObj.min) || 0;
          max = Number(rangeObj.max);
        }
        arr.push({
          min,
          max,
          itemCode:se.itemCode
        });
      });

      setCustomAxisRanges(arr);
    }
  }, [item]);
  function roundUpByDigit(num) {
    if (isNaN(num) || num === 0) return 10;

    const sign = num < 0 ? -1 : 1;
    const absNum = Math.abs(num);
  
    let step;
  
    if (absNum < 1000) {
      step = 10;
    } else {
      const digits = Math.pow(10, Math.floor(Math.log10(absNum)));
      step = digits / 10;
    }
  
    const remainder = absNum % step;
    const rounded = remainder === 0 ? absNum : absNum + (step - remainder);
  
    return rounded * sign;
  }

  const generateTicks = (min, max) => {
    if (min === undefined || max === undefined || min >= max) return undefined;

    const ticks = [];
    const numberOfTicks = 6;
    const step = (max - min) / (numberOfTicks - 1);

    for (let i = 0; i < numberOfTicks; i++) {
      ticks.push(parseFloat((min + step * i).toFixed(4)));
    }

    return ticks;
  };
  const rangeKey = (itemCode) => "range-"  + machineCode + "-" + itemCode;

  const getYAxis = (x, index) => {
    const isCustomMinMax = +x.min || +x.max;
    const itemCode = x.itemCode;
    const objRanges = customAxisRanges.find(i => i.itemCode == itemCode);


    // const objMinMax = isCustomMinMax
    //   ? { min: customAxisRanges[index].min, max: customAxisRanges[index].max }
    //   : {};
    const plotLinesOption = {
      value: "",
      label: {
        text: "",
        align: "right",
        style: {
          color: "red",
        },
        x: -10,
      },
      color: "red",
      width: 2,
      dashStyle: "dash",
    };

    return {
      tickPixelInterval: 40,
      scrollablePlotArea: {
        minHeight: 100,
        maxHeight: 200,
      },
      title: {
        text: "",
        style: {
          color: x.color,
        },
      },
      labels: {
        overflow: "allow",
        padding: 1,
        allowOverlap: true,
        style: {
          color: x.color,
          fontSize: 10,
        },
      },
      plotLines:
        showThreshold === x.name + x.machineName
          ? [
              {
                ...plotLinesOption,
                value: x.normalLowerControlValue,
                label: {
                  ...plotLinesOption.label,
                  text: "運転めやす(下): " + x.normalLowerControlValue,
                  align: "left",
                  y:15
                },
              },
              {
                ...plotLinesOption,
                value: x.normalUpperControlValue,
                label: {
                  ...plotLinesOption.label,
                  text: "運転めやす(上): " + x.normalUpperControlValue,
                },
              },
            ]
          : [],
      tickPositioner: function () {
        const min =
          objRanges && objRanges.min == 0
            ? objRanges.min
            : (objRanges && objRanges.min) ||
              roundUpByDigit(this.min);
        const max =
          (objRanges && objRanges.max) ||
          roundUpByDigit(this.max);
        return generateTicks(min, max);
      },
    };
  };
  const handleMouseOver = (e) => {
    const id = e.target.userOptions.name + e.target.userOptions.machineName;
    if (!showThreshold) {
      setShowThreshold(id);
    }
  };
  const handleMouseOut = () => {
    if (showThreshold) {
      setShowThreshold(false);
    }
  };

  const linkYaxis = (x, i, item) => ({
    ...x,
    yAxis: item.length - i - 1,
    events: {
      mouseOver: handleMouseOver,
      mouseOut: handleMouseOut,
    },
  });
  const [form] = Form.useForm();

  const [triggerChart, setTriggerChart] = useState(false);
  const [type, updateType] = useState(item.type);
  const [options, updateOptions] = useState(null);
  const [showThreshold, setShowThreshold] = useState(false);
  const [editingValueType, setEditingValueType] = useState(null);
  const [currentMin, setCurrentMin] = useState(null);
  const [currentMax, setCurrentMax] = useState(null);
  useEffect(() => {
    updateOptions({
      ...chartLine,
      chart: {
        spacingTop: 30,
        spacingRight: 60,
        scrollablePlotArea: {
          minWidth: 800,
          scrollPositionX: 1,
        },
        events: {
          render: function () {
            const chart = this;
            chart.yAxis.forEach((axis, index) => {
              let itemCode;
              const axisSeries = chart.series.filter(s => s.yAxis === axis);
              if(Array.isArray(axisSeries) && axisSeries.length > 0){
                itemCode = axisSeries[0].userOptions ?  axisSeries[0].userOptions.itemCode : ""
              }
              const ticks = axis.ticks;
              Object.values(ticks).forEach((tick) => {
                const label = tick.label;
                if (!label || !label.element) return;

                label.element.onclick = null;

                if (tick.pos === axis.min) {
                  label.element.style.cursor = "pointer";
                  label.element.onclick = () => {
                    setEditingAxisIndex(itemCode);
                    setEditingValueType("min");
                    form.setFieldsValue({ value: axis.min });
                    setIsModalVisible(true);
                    setCurrentMax(axis.max);
                  };
                } else if (tick.pos === axis.max) {
                  label.element.style.cursor = "pointer";
                  label.element.onclick = () => {
                    setEditingAxisIndex(itemCode);
                    setEditingValueType("max");
                    form.setFieldsValue({ value: axis.max });
                    setIsModalVisible(true);
                    setCurrentMin(axis.min);
                  };
                } else {
                  label.element.style.cursor = "default";
                }
              });
            });
          },
        },
      },
      series: [...item.series.map(linkYaxis)],
      xAxis: {
        ...chartLine.xAxis,
        categories: item.categories,
        labels: {
          step: item.categories.length
            ? Math.ceil(item.categories.length / 12)
            : 1,
          rotation: -30,
          y: 40,
        },
      },
      yAxis: [...item.series].map(getYAxis),
      legend: {
        layout: isChartItem ? "vertical" : "horizontal",
        align: isChartItem ? "left" : "center",
        verticalAlign: isChartItem ? "top" : "bottom",

        enabled: true,
        useHTML: true,
        labelFormatter: function () {
          return !isPopup
            ? `<span title="${this.userOptions.machineName}">${this.name} (${
                this.userOptions.unit || ""
              })</span>`
            : "<span>" + this.name + "</span>";
        },
      },
    });
  }, [item, customAxisRanges]);

  const transTextEllipsis = (text, skip = 30) => {
    if (text && text.length) {
      let newText = "";
      for (let i = 0; i < text.length; i++) {
        if (i < skip) {
          newText += text[i];
        } else {
          newText += " ...";
          break;
        }
      }
      return newText;
    } else {
      return null;
    }
  };

  const [optionsDisplay, setOptionsDisplay] = useState(options);
  useEffect(() => {
    const newSeries = item.series;
    setOptionsDisplay({
      ...options,
      series: newSeries.map(linkYaxis),
      yAxis: [...newSeries].reverse().map(getYAxis),
    });
  }, [options, showThreshold]);

  // Trigger chart
  useEffect(() => {
    setTriggerChart(!triggerChart);
  }, [type]);

  const showConfirmMessage = async(
    msg,
    callbackOK,
    callbackCancel,
    typeInfo = false
  ) => {
    const values = await form.validateFields();
    const newValue = Number(values.value);
    if (isNaN(newValue)) {
      return;
    }
    let ok, cancel;
    const callBackDefault = () => {
      Modal.destroyAll();
    };

    // Callback OK exist
    if (callbackOK) {
      ok = () => {
        callbackOK();
        callBackDefault();
      };
    }
    // Callback Cancel exist
    if (callbackCancel) {
      cancel = () => {
        callbackCancel();
        callBackDefault();
      };
    }

    Modal.confirm({
      centered: true,
      icon: <QuestionCircleOutlined />,
      title: lang.CONFIRM,
      content: msg,
      okText: lang.OK,
      cancelText: lang.CANCEL,
      onCancel: cancel || callBackDefault,
      onOk: ok || callBackDefault,
    });
  };
  
  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      const newValue = Number(values.value);
      if (isNaN(newValue)) {
        return;
      }

      const indexUpdate  = customAxisRanges.findIndex(i => i.itemCode == editingAxisIndex );
      if(indexUpdate < 0){
        showMessage(KEY.ERROR,MSG_CATCH());
        return;
      }

      setCustomAxisRanges((prev) => {
        const updated = [...prev];
        if (editingValueType === "min") {
          updated[indexUpdate] = {
            ...updated[indexUpdate],
            min: newValue,
          };
        } else {
          updated[indexUpdate] = {
            ...updated[indexUpdate],
            max: newValue,
          };
        }
        return updated;
      });

      setIsModalVisible(false);
      setTriggerChart(!triggerChart);

      // SAVE SESSION
      if (
        item &&
        item.series &&
        Array.isArray(item.series) &&
        item.series.length
      ) {
        const itemCode = customAxisRanges[indexUpdate].itemCode;
        const dataSave = {
          ...customAxisRanges[indexUpdate],
          [editingValueType]: newValue,
        };
        try {
          sessionStorage.setItem(rangeKey(itemCode), JSON.stringify(dataSave));
        } catch (error) {
          console.log(error);
        }
      }
      showMessage(KEY.INFO, "正常に保存しました。")
    } catch (err) {
      console.log("Validation Failed:", err);
    }
  };
  const handleCancel = () => setIsModalVisible(false);

  return (
    <Row
      key={index + item.id}
      className="rowNotMargin chart-bg all-dynamic-chartt"
      gutter={[24, 32]}
    >
      <Col span={24} className="mb8" style={{ padding: "4px" }}>
        <Row
          className="rowNotMargin "
          justify="space-between"
          align="middle"
          gutter={[0, 8]}
        >
          <Col style={{fontSize:16}} className=" text-center">
            <>
              <span style={{ fontWeight: "normal" }}>機器：</span>
              <span style={{ fontWeight: "bold" }}>
                <Tooltip title={item.machineName || machineName} zIndex="100000">
                  {transTextEllipsis(item.machineName || machineName)}
                </Tooltip>
              </span>
            </>
          </Col>
        </Row>
      </Col>

      {!item.isHasData && (
        <>
          <Col span={24} className="p4 text-center">
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="データがありません"
            />
          </Col>
        </>
      )}

      <Col span={24} className={` text-center p4`}>
        {item.isHasData && (
            <HighchartsReact
            key={triggerChart}
            highcharts={Highcharts}
            options={optionsDisplay}
            callback={(chart) => {
              chart.renderTo.setAttribute("id", "chart-equipment-info");
            }}
            // immutable={true}
          />
        )}
      </Col>
      <Modal
        title={editingValueType === "max" ? "上限値編集" : "下限値編集"}
        visible={isModalVisible}
        onOk={() => showConfirmMessage("登録してもよろしいですか？",handleOk)}
        onCancel={handleCancel}
        destroyOnClose
        centered={true}
      >
        <Form form={form} layout="vertical" name="axis_value_form">
          <Form.Item
            name="value"
            // label={maxLabel}
            rules={[
              { required: true, message: "" },
              {
                pattern: /^-?\d*\.?\d+$/,
                message: "",
              },
              {
                validator: (_, value) => {
                  if (value === undefined || value === null || value === "") {
                    return Promise.resolve();
                  }
                  const num = Number(value);
                  if (
                    (editingValueType === "min" && currentMax <= num) ||
                    (editingValueType === "max" && currentMin >= num)
                  ) {
                    return Promise.reject(
                      editingValueType === "max"
                        ? "上限値は下限値より大きく入力してください。"
                        : "下限値は上限値より小さく入力してください。"
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input type="number" autoFocus />
          </Form.Item>
        </Form>
      </Modal>
    </Row>
  );
}

export default EquipmentChart;
